<template>
  <div>
    <div class="main">
      <div class="wrapper">
        <img class="logo" src="@/assets/new_logo.png">
      </div>
    </div>
    <div class="menu">
      <div class="wrapper">
        <div class="block" v-for="(item,index) in permission_routes" :key="index" @click="linkTo(item)">
          <div class="title">
            {{ item.meta.title }}
            <img v-if="item.children !== undefined && item.children.length > 1" src="@/assets/icon_arrow_down@1x.png">
            <div v-if="item.children !== undefined && item.children.length > 1" class="mask">
              <div v-for="(subMenu, i) in item.children" :key="i" @click.stop="linkToSubMenu(item.path, subMenu.path)">
                {{ subMenu.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Header',
  created() {
  },
  methods: {
    linkTo(path) {
      this.$router.push({name: path.children[0].name})
    },
    linkToSubMenu(parentPath, subMenuPath) {
      this.$router.push({path: parentPath + '/' + subMenuPath})
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ])
  }
}
</script>

<style scoped lang="scss">
.main {
  width:100%;
  height:164px;
  background:rgba(29,31,62,1);
  display: flex;
  justify-content: center;
  .head-title {
    margin-top: 30px;
    margin-left: -50%;
    width: 1152px;
    height: 164px;
    color: white;
    font-size: 35px;
  }
  .wrapper {
    width: 1152px;
    height: 164px;
  }
  .logo {
    display: block;
    width:  270px;
    margin-top: 20px;
    margin-left: 0;
  }
}
.menu {
  float: left;
  margin-top: -59px;
  width:100%;
  height:59px;
  background:rgba(216,34,31,1);
  font-size: (18px);
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  color:rgba(255,255,255,1);
  line-height:25px;
  display: flex;
  justify-content: center;
  .wrapper {
    margin-top: 15px;
    z-index: 10;
    height: 100%;
    width: 1152px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .block {
    height: 100%;
    flex: 1;
    display: inline;
    cursor: pointer;
    text-align: center;
    vertical-align: middle ;
    .title {
      vertical-align: center;
    }
    img {
      vertical-align: middle ;
      width: 20px;
      height: 20px;
      margin-left: 2px;
    }
    .mask {
      display: block;
      margin-top: 20px;
      width: 150%;
      max-height:0;
      overflow: hidden;
      background:rgba(216,34,31,1);
      font-size: (18px);
      font-weight: 400;
      text-align: left;
      div{
        padding: 10px;
        border-bottom: solid 1px rgba(172, 172, 172, 1);
      }
    }
  }
  .block:hover .mask {
    -webkit-transition: all 0.7s linear;
    -moz-transition: all 0.7s linear;
    transition: all 0.7s linear;
    max-height: 500px;
  }
  .block:hover img {
    content: url("../assets/icon_arrow_up@1x.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue